/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResourceGroup } from '../../models/resource-group';

export interface FindAll2$Params {
  page?: number;
  count?: number;
  sort?: string;
  dir?: 'ASC' | 'DESC';
  status?: 'ACTIVE' | 'INACTIVE';
}

export function findAll2(http: HttpClient, rootUrl: string, params?: FindAll2$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResourceGroup>>> {
  const rb = new RequestBuilder(rootUrl, findAll2.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('count', params.count, {});
    rb.query('sort', params.sort, {});
    rb.query('dir', params.dir, {});
    rb.query('status', params.status, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ResourceGroup>>;
    })
  );
}

findAll2.PATH = '/api/values/resource-groups';
